module.exports = __webpack_public_path__ + "static/img/day_report_win2.7ec51ef3.png";